export const hasToken = ({ token }) => !!token;
export const getEmpresa = ({ empresa }) => empresa;